module.exports = __webpack_public_path__ + "static/media/LazyAz_web1_preview.dd281095.jpg";